import { defineMessages } from 'react-intl';

export default defineMessages({
    businessType: {
        id: 'guidance.directives.questions.Almost there, pick at least one that applies to your business.',
        defaultMessage: 'Almost there, pick at least one that applies to your business.'
    }
});
